//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample, SampleHero } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import { useFormikContext } from "formik";
import { useEffect } from "react";

export default function ProductOption({
  product,
  optionList,
  key,
  title,
  getVariantDetail,
}) {
  const { values, setFieldValue } = useFormikContext();

  const getSoldOutVariant = () => {
    if (product?.product_variants?.length > 0) {
      const optionTypes = Array.from(
        new Set(
          product.product_variants.flatMap((variant) =>
            variant.option_values.map((opt) =>
              opt.option_type.name.toLowerCase()
            )
          )
        )
      );

      const soldOut = {};

      optionTypes.forEach((optionType) => {
        // if (values.options.hasOwnProperty(optionType)) {
        const possibleValues = Array.from(
          new Set(
            product.product_variants.flatMap((variant) =>
              variant.option_values
                .filter(
                  (opt) => opt.option_type.name.toLowerCase() === optionType
                )
                .map((opt) => opt.value.toLowerCase())
            )
          )
        );

        const unavailableValues = possibleValues.filter((value) => {
          const candidate = { ...values.options, [optionType]: value };
          const available = product.product_variants.some((variant) => {
            const matches = Object.keys(candidate).every((key) => {
              const opt = variant.option_values.find(
                (o) => o.option_type.name.toLowerCase() === key
              );

              return (
                opt && opt.value.toLowerCase() === candidate[key].toLowerCase()
              );
            });

            return matches && Number(variant.quantity) > 0;
          });
          return !available;
        });

        soldOut[optionType] = unavailableValues;
        // }
      });

      return soldOut;
    }
    return null;
  };

  const soldOutOptions = getSoldOutVariant() || {};

  const handleSelectOption = (type, value) => {
    setFieldValue(`options[${type}]`, value);
  };

  useEffect(() => {
    setFieldValue("variant_id", getVariantDetail(values.options));
  }, [values.options]);

  return (
    <Container tag="article" className="product-option">
      <Row className="h-flex gap-2">
        <h4 className="_label option-title">{title}</h4>
        {values.options[title.toLowerCase()] && (
          <>
            <p className="_label option-dot">•</p>
            <p className="_label option">
              {values.options[title.toLowerCase()]}
            </p>
          </>
        )}
      </Row>
      <Row className="_row option-list">
        {optionList.map((option, optionIndex) => {
          const isSoldOut =
            soldOutOptions[title.toLowerCase()]?.length > 0 &&
            soldOutOptions[title.toLowerCase()]?.includes(option.toLowerCase());

          return (
            <Col className="_col option-item pointer" key={optionIndex}>
              {option.image ? (
                <Image
                  className={`_img option ${
                    optionIndex === 0 ? "--active" : ""
                  }`}
                  src={option.image}
                />
              ) : (
                <article
                  className={`option-item-frame ${
                    isSoldOut
                      ? "--disabled"
                      : values.options[title.toLowerCase()] === option
                      ? "--active"
                      : ""
                  }`}
                  onClick={() => {
                    if (!isSoldOut) {
                      handleSelectOption(title.toLowerCase(), option);
                    }
                  }}
                >
                  <h6 className="_label option-item-title">{option}</h6>
                </article>
              )}
            </Col>
          );
        })}
      </Row>
    </Container>
  );
}
